import React, { useState } from "react";
import { Stepper, Step, StepLabel, Box, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import StepHighSchool from "./StepHighSchool";
import StepHigherSecondary from "./StepHigherSecondary";
import StepDiploma from "./StepDiploma";
import StepUndergraduate from "./StepUndergraduate";
import StepPostgraduate from "./StepPostgraduate";
import { useNavigate } from "react-router-dom";

const steps = [
  "High School",
  "Higher Secondary",
  "Diploma",
  "Undergraduate",
  "Postgraduate",
];

const EducationStepper = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    } else {
      navigate('/candidate/address-info'); // Navigate to previous page before stepper
    }
  };

  const getStepComponent = () => {
    switch (activeStep) {
      case 0:
        return <StepHighSchool onNext={() => setActiveStep(1)} onBack={handleBack} />;
      case 1:
        return <StepHigherSecondary onNext={() => setActiveStep(2)} onBack={handleBack} />;
      case 2:
        return <StepDiploma onNext={() => setActiveStep(3)} onBack={handleBack} />;
      case 3:
        return <StepUndergraduate onNext={() => setActiveStep(4)} onBack={handleBack} />;
      case 4:
        return <StepPostgraduate onNext={() => setActiveStep(5)} onBack={handleBack} />;
    }
  };

  return (
    <Box sx={{ width: "100%", padding: 4 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Box sx={{ mt: 2 }}>{getStepComponent()}</Box>
    </Box>
  );
};

export default EducationStepper;